import { SELECTABLE_ITEM_TYPE, TABLE_GRID } from 'modules/workflowIndex/constants';

import { GridRow } from 'ui/indexPages/tables/grid';

import { Workflow, WorkflowCreatorOrModifierUser, WorkflowId, WorkflowType } from '../../types';

import { WorkflowRowOverflowMenu } from './WorkflowRowOverflowMenu';
import { WorkflowSendActivityCell } from './WorkflowSendActivityCell';
import { WorkflowTriggerCell } from './WorkflowTriggerCell';
import { WorkflowLastModifiedCell } from './WorkflowLastModifiedCell';
import { WorkflowStatusCell } from './WorkflowStatusCell';
import { WorkflowNameCell } from './WorkflowNameCell';
import { CheckboxCell } from './CheckboxCell';

type WorkflowRowProps = {
  workflow: Workflow;
  creatorAndModifierUsersById: Record<string, WorkflowCreatorOrModifierUser>;
  onArchiveOptionClick: (workflowId: WorkflowId) => void;
  onUnarchiveOptionClick: (workflowId: WorkflowId) => void;
  onCopyOptionClick: (workflowId: WorkflowId) => void;
  onDeleteOptionClick: (workflowId: WorkflowId) => void;
  onEnableOptionClick: (workflowId: WorkflowId) => void;
  onDisableOptionClick: (workflowId: WorkflowId) => void;
  onMoveOptionClick: (workflowId: WorkflowId) => void;
};

export const WorkflowRow = ({
  workflow,
  onArchiveOptionClick,
  onUnarchiveOptionClick,
  onCopyOptionClick,
  onDeleteOptionClick,
  onEnableOptionClick,
  onDisableOptionClick,
  onMoveOptionClick,
  creatorAndModifierUsersById,
}: WorkflowRowProps) => (
  <GridRow gridLayout={TABLE_GRID}>
    <CheckboxCell
      itemType={
        workflow.workflowType === WorkflowType.DRAFT
          ? SELECTABLE_ITEM_TYPE.WORKFLOW_DRAFT
          : SELECTABLE_ITEM_TYPE.WORKFLOW
      }
      itemId={workflow.id}
    />
    <WorkflowNameCell data-test="workflow-name-cell" workflow={workflow} />
    <WorkflowStatusCell workflow={workflow} />
    <WorkflowTriggerCell workflow={workflow} />
    <WorkflowSendActivityCell workflow={workflow} />
    <WorkflowLastModifiedCell
      workflow={workflow}
      creatorAndModifierUsersById={creatorAndModifierUsersById}
    />
    <WorkflowRowOverflowMenu
      workflow={workflow}
      onArchiveOptionClick={onArchiveOptionClick}
      onUnarchiveOptionClick={onUnarchiveOptionClick}
      onCopyOptionClick={onCopyOptionClick}
      onDeleteOptionClick={onDeleteOptionClick}
      onEnableOptionClick={onEnableOptionClick}
      onDisableOptionClick={onDisableOptionClick}
      onMoveOptionClick={onMoveOptionClick}
    />
  </GridRow>
);
